var map = {
	"./de.json": [
		16494,
		6494
	],
	"./en.json": [
		59748,
		9748
	],
	"./es.json": [
		60124,
		124
	],
	"./eu.json": [
		60968,
		968
	],
	"./fr.json": [
		43851,
		3851
	],
	"./it.json": [
		45361,
		5361
	],
	"./ja.json": [
		84328,
		4328
	],
	"./nl.json": [
		5706,
		5706
	],
	"./pt.json": [
		82275,
		2275
	],
	"./pt_BR.json": [
		14943,
		4943
	],
	"./ro.json": [
		51640,
		1640
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 71539;
module.exports = webpackAsyncContext;